@if(this.isAdmin) {
<article class="admin-check-modal__container">
  <section id="backdrop"></section>
  <section class="modal">
    <section class="modal__top">
      <h2 class="text--lg text--semibold gray-900">Vérification</h2>
      <svg
        (click)="cancel()"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        aria-hidden="true"
        role="img"
        width="45px"
        height="45px"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 24 24"
      >
        <path
          d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z"
          fill="#667085"
        />
      </svg>
    </section>
    <form (ngSubmit)="verify()">
      <section class="input--row--w100">
        <label class="text--sm text--medium gray-600">Mot de passe *</label>
        <section class="input--container">
          <input
            type="password"
            name="password"
            class="input--text"
            [formControl]="verfifPasswordControl"
          />
        </section>
      </section>
      <section class="input--row--w100 input--row--submit">
        <button
          [disabled]="verfifPasswordControl.invalid"
          class="btn btn--primary btn--sm"
        >
          Valider
        </button>
      </section>
    </form>
  </section>
</article>
}
